class ModalPpeTopSuccess {

    constructor(options) {
        this.options = Object.assign(ModalPpeTopSuccess.options, options);
    }

    getOptions() {
        return this.options;
    }
}

ModalPpeTopSuccess.options = {
    visibility: true,
    type: 'success',
    button: [{
        message: "Ver",
        callback: (scopeModal) => {
            scopeModal.closeModal();
            {
                ModalPpeTopSuccess.options.props.redirect()
            }
        }
    }],
    positionButtons: 'flex-end'
};

export default ModalPpeTopSuccess;